export default __webpack_public_path__ + "static/media/number-bg.5697c940.webp";